// Firebase configuration
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getAnalytics } from 'firebase/analytics'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyBwWYbl-n-YTET25dsQ4OFvOQvT-kRZoFU",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "aums-2025.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "aums-2025",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "aums-2025.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "619565673640",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:619565673640:web:a82c822b40e571a1ace69d",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-X21YGVZ92S"
}

// Initialize Firebase
let app, auth, db, storage, analytics

try {
  app = initializeApp(firebaseConfig)
  auth = getAuth(app)
  db = getFirestore(app)
  storage = getStorage(app)
  
  // Initialize Analytics only in browser environment
  if (typeof window !== 'undefined') {
    analytics = getAnalytics(app)
  }
  
  console.log('✅ Firebase initialized successfully')
  console.log('📊 Project ID:', firebaseConfig.projectId)
} catch (error) {
  console.warn('⚠️ Firebase initialization failed:', error.message)
  console.warn('⚠️ Please configure your Firebase credentials in .env file')
  
  // Create mock objects for development
  auth = null
  db = null
  storage = null
  analytics = null
}

export { auth, db, storage, analytics }
export default app
